import React, { useEffect, useState } from "react";
import Head from "next/head";
// Components
import { TopbarLanding } from "../../components/LandingPage/topbar";
import { getPaginatedPosts } from "../../services/CMSBlogService";

import Banner from "./home/components/Banner";
import Blog from "../../components/LandingPage/Blog/Blog";
import SuccessCases from "./home/components/SuccessCases";
import VerzelDna from "../../components/LandingPage/VerzelDna/VerzelDna";
import { Footer } from "../../components/LandingPage/footer";
import { BusinessDivision } from "../../components/LandingPage/BusinessDivision/BusinessDivision";
import { fetchAllUserImages } from "./home/components/Banner/fetchAllUserImages";
import { getI18nProps, getStaticPaths } from "../../lib/next-i18next/getStatic";
import { Contact } from "../../components/LandingPage/Contact";
import { FaceLiftGlobalStyle } from "../../styles/theme";
import DefaultDarkModeHOC from "../../components/theme/DefaultDarkModeHOC";

const HomePageMeta = ({ translations }) => {
	return (
		<Head>
			<title>{translations.meta.title}</title>
			<meta name="title" content={translations.meta.title} />
			<meta name="description" content={translations.meta.description} />

			<meta property="og:type" content="website" />
			<meta
				property="og:url"
				content={process.env.NEXT_PUBLIC_WEBSITE_DOMAIN}
			/>
			<meta property="og:title" content={translations.meta.title} />
			<meta property="og:description" content={translations.meta.description} />
			<meta
				property="og:image"
				content={`${process.env.NEXT_PUBLIC_WEBSITE_DOMAIN}/landings/assets/images/LogoVerzelHorizontal.svg`}
			/>

			<meta property="twitter:card" content="summary_large_image" />
			<meta
				property="twitter:url"
				content={process.env.NEXT_PUBLIC_WEBSITE_DOMAIN}
			/>
			<meta property="twitter:title" content={translations.meta.title} />
			<meta
				property="twitter:description"
				content={translations.meta.description}
			/>
			<meta
				property="twitter:image"
				content={`${process.env.NEXT_PUBLIC_WEBSITE_DOMAIN}/landings/assets/images/LogoVerzelHorizontal.svg`}
			/>
		</Head>
	);
};

const HomePage = ({ blogPosts, _nextI18Next, locale }) => {
	const translations = _nextI18Next.initialI18nStore[locale].translation;
	const [mounted, setMounted] = useState(false);

	useEffect(() => {
		setMounted(true);
	}, []);

	return (
		<DefaultDarkModeHOC>
			<HomePageMeta translations={translations} />
			<FaceLiftGlobalStyle />
			<TopbarLanding />
			<Banner />
			<BusinessDivision />
			<VerzelDna />
			<Blog posts={blogPosts} />
			<SuccessCases />
			{mounted && <Contact />}
			<Footer />
		</DefaultDarkModeHOC>
	);
};

export const getStaticProps = async (ctx) => {
	const i18nProps = await getI18nProps(ctx);
	const postsResponse = await getPaginatedPosts({
		search: undefined,
		limit: 9,
		page: 1,
		locale: i18nProps._nextI18Next.initialLocale,
	});

	return {
		props: {
			...i18nProps,
			blogPosts: postsResponse?.posts ?? [],
			locale: i18nProps._nextI18Next.initialLocale,
		},
	};
};

export { getStaticPaths };

export default HomePage;
